import axios from './axios';

const API_URL = '/admin/vendor-deposits';
const VENDOR_LIST_URL = '/admin/vendor-list';

/**
 * Vendor Deposit API Functions
 * Handles all CRUD operations for vendor petty cash deposits
 * Manages API calls to backend vendor deposit endpoints with error handling
 */
export const vendorDepositApi = {
  // Get vendor deposits with optional vendor filtering
  getDeposits: async (vendorId = null) => {
    try {
      const params = vendorId ? { vendor_id: vendorId } : {};
      const response = await axios.get(API_URL, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Get specific vendor deposit by ID
  getDeposit: async (id) => {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Create new vendor deposit with file upload support
  createDeposit: async (depositData) => {
    try {
      const response = await axios.post(API_URL, depositData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

// Update existing vendor deposit with file upload support
updateDeposit: async (id, depositData) => {
  try {
    const response = await axios.post(`${API_URL}/${id}`, depositData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
},


  // Delete vendor deposit record by ID
  deleteDeposit: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Get vendor list for dropdown selection
  getVendors: async () => {
    try {
      const response = await axios.get(VENDOR_LIST_URL);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Get vendor deposits for the authenticated vendor (vendor role)
  getVendorDeposits: async () => {
    try {
      const response = await axios.get('/vendor/deposits');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Sync vendor deposits with expense history (admin only)
  syncDeposits: async (vendorId = null) => {
    try {
      const data = vendorId ? { vendor_id: vendorId } : {};
      const response = await axios.post('/admin/vendor-deposits/sync', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Get expenses for a specific deposit
  getDepositExpenses: async (depositId) => {
    try {
      const response = await axios.get(`/vendor-expenses/deposit/${depositId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  }
}; 